module.exports = __webpack_public_path__ + "static/img/4-2.aa3bcc13.jpg";